import React, {useState} from 'react';



function BoolEditorGoogleAttributes ({googleAttribute, cmAttribute, onChange, onDelete}){


    const handleClick = () => {
        onDelete(cmAttribute)
    }

    const handleOptionChange = (on) => (event) => {
        const newValue = (event.target.checked) ? on : undefined;
        const cmGoogleAttribute = {attributeId: googleAttribute.attributeId,
            valueType: googleAttribute.valueType,  values: [newValue]}

        onChange(cmGoogleAttribute)
    };

    return <div>
            <table style={{"width": "100%"}}>
                <tbody style={{"width": "100%"}}>
                <tr>
                    <td style={{"width": "180px"}}>{/* Set width on first column so everything lines up nicely */}{googleAttribute.displayName}</td>
                    <td style={{"width": "200px"}}>
                        <div className="custom-control custom-checkbox control-spacer-left inline-block">
                            <input type="checkbox" id={cmAttribute.attributeId + "-yes"} className="custom-control-input" checked={cmAttribute.values[0] == true}  onChange={handleOptionChange(true)} />
                            <label className="custom-control-label" htmlFor={cmAttribute.attributeId + "-yes"}>Yes &nbsp;</label>
                        </div>
                        <div className="custom-control custom-checkbox control-spacer-left inline-block">
                            <input type="checkbox" id={cmAttribute.attributeId + "-no"} className="custom-control-input" checked={cmAttribute.values[0] == false}  onChange={handleOptionChange(false)} />
                            <label className="custom-control-label" htmlFor={cmAttribute.attributeId + "-no"}>No&nbsp;{" "}</label>
                        </div>
                    </td>
                    <td>
                        <label>
                            <button type="button" className="btn btn-light"
                                    onClick={handleClick}>
                                <svg width="1em" height="1em" viewBox="0 0 16 16" className="bi bi-x-circle-fill"
                                     fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd"
                                          d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-4.146-3.146a.5.5 0 0 0-.708-.708L8 7.293 4.854 4.146a.5.5 0 1 0-.708.708L7.293 8l-3.147 3.146a.5.5 0 0 0 .708.708L8 8.707l3.146 3.147a.5.5 0 0 0 .708-.708L8.707 8l3.147-3.146z"/>
                                </svg>
                            </button>
                        </label>
                    </td>
                </tr>
                </tbody>
            </table>
        {cmAttribute.values[0] == undefined && <small id="boolError" className="text-danger">
        Must make a selection.
        </small>}

    </div>

}

export default BoolEditorGoogleAttributes;